import { render, staticRenderFns } from "./HomePrompt.vue?vue&type=template&id=6f3d2874&scoped=true&"
import script from "./HomePrompt.vue?vue&type=script&lang=ts&"
export * from "./HomePrompt.vue?vue&type=script&lang=ts&"
import style0 from "./HomePrompt.vue?vue&type=style&index=0&id=6f3d2874&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3d2874",
  null
  
)

export default component.exports